<template>
  <AIBasePanel
    :title="title"
    @close="emit('close')"
  >
    <template #toolbarLeft>
      <BaseButton
        circle
        flat
        icon="chevron-left"
        :label="backButtonLabel"
        new-design
        new-icon
        @click="handleBackButton"
      />
    </template>

    <AISummaryChatHistory
      v-if="sourceType === 'stream_summary'"
      data-testid="summary-history"
      :message="messages[0]"
    />

    <AIChatHistory
      v-else
      data-testid="chat-history"
      :messages="messages"
    />
  </AIBasePanel>
</template>

<script setup lang="ts">
import { computed, inject, onMounted } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import AIBasePanel from "shared/components/AI/AIBasePanel.vue";
import AIChatHistory from "shared/components/AI/AIChatHistory/AIChatHistory.vue";
import AISummaryChatHistory from "shared/components/AI/AISummary/AISummaryChatHistory.vue";
import { BaseButton } from "shared/components/base";
import { useAIChatHistory } from "shared/composables/useAIChatHistory";
import { useAIStore } from "shared/stores/ai";

const { messages, sourceType, title, getAIHistory } = useAIChatHistory();

const aiStore = useAIStore();
const { openAIModal } = aiStore;
const groupId = computed(() => aiStore.aiBooleanCreatorChatHistoryGroupId);

const emit = defineEmits(["close"]);

const isDesktop = inject<boolean>("isDesktop", false);

const backButtonLabel = computed<string>(() =>
  isDesktop ? getLocaleText("ai_boolean_creator_chat_history.title") : ""
);

function handleBackButton() {
  openAIModal("AIChatHistoryListPanel");
}

onMounted(() => {
  getAIHistory(groupId.value);
});
</script>
